import './PointsAmount.css';

type PointsAmountProps = {
  value: number;
};

const PointsAmount = ({ value }: PointsAmountProps) => {
  const positive = value >= 0;
  return (
    <span className={`points-amount ${positive ? 'is-positive' : 'is-negative'}`}>
      {positive ? '+' : ''}{value}
    </span>
  );
};

export default PointsAmount;
